/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeliverTransportEquipmentCountInput = {
  billNumber: string;
  dateOfPickup: string;
  deliveryImageUrls: Array<string>;
  externalSupplierId: string | number;
  lineItems: Array<TransportEquipmentLineItemInput>;
  transportEquipmentCountId?: string | number | null | undefined;
};

export type SaveTransportEquipmentCountInput = {
  externalSupplierId: string | number;
  lineItems: Array<TransportEquipmentLineItemInput>;
};

export type TransportEquipmentCountStatus = "DELIVERED" | "PENDING";

export type TransportEquipmentLineItemInput = {
  equipmentTypeId: string | number;
  received: number;
  returned: number;
};

export type GetActiveEquipmentTypesForSupplierQueryVariables = Exact<{
  externalSupplierId: string | number;
}>;

export type GetActiveEquipmentTypesForSupplierQuery = {
  getActiveEquipmentTypesForSupplier: {
    equipmentTypes: Array<{
      id: string;
      name: string;
      photoUrl: string;
      depositInEuros: number | null;
      createdAt: string;
    }>;
  };
};

export type GetTransportEquipmentCountsQueryVariables = Exact<{
  externalSupplierId: string | number;
  status: Types.TransportEquipmentCountStatus;
}>;

export type GetTransportEquipmentCountsQuery = {
  getTransportEquipmentCounts: {
    transportEquipmentCounts: Array<{
      id: string;
      status: Types.TransportEquipmentCountStatus;
      externalSupplierId: string;
      billNumber: string | null;
      dateOfPickup: string | null;
      deliveryImageUrls: Array<string>;
      createdAt: string;
      updatedAt: string | null;
      actor: string | null;
      lineItems: Array<{
        equipmentTypeId: string;
        name: string;
        returned: number;
        received: number | null;
        photoUrl: string;
        depositInEuros: number | null;
      }>;
    }>;
  };
};

export type DeliverTransportEquipmentCountMutationVariables = Exact<{
  input: Types.DeliverTransportEquipmentCountInput;
}>;

export type DeliverTransportEquipmentCountMutation = {
  deliverTransportEquipmentCount: { success: boolean };
};

export type SaveTransportEquipmentCountMutationVariables = Exact<{
  input: Types.SaveTransportEquipmentCountInput;
}>;

export type SaveTransportEquipmentCountMutation = {
  saveTransportEquipmentCount: { success: boolean };
};

export const GetActiveEquipmentTypesForSupplierDocument = gql`
  query GetActiveEquipmentTypesForSupplier($externalSupplierId: ID!) {
    getActiveEquipmentTypesForSupplier(externalSupplierId: $externalSupplierId) {
      equipmentTypes {
        id
        name
        photoUrl
        depositInEuros
        createdAt
      }
    }
  }
`;

/**
 * __useGetActiveEquipmentTypesForSupplierQuery__
 *
 * To run a query within a React component, call `useGetActiveEquipmentTypesForSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveEquipmentTypesForSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveEquipmentTypesForSupplierQuery({
 *   variables: {
 *      externalSupplierId: // value for 'externalSupplierId'
 *   },
 * });
 */
export function useGetActiveEquipmentTypesForSupplierQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  > &
    (
      | { variables: GetActiveEquipmentTypesForSupplierQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  >(GetActiveEquipmentTypesForSupplierDocument, options);
}
export function useGetActiveEquipmentTypesForSupplierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  >(GetActiveEquipmentTypesForSupplierDocument, options);
}
// @ts-ignore
export function useGetActiveEquipmentTypesForSupplierSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetActiveEquipmentTypesForSupplierQuery,
  GetActiveEquipmentTypesForSupplierQueryVariables
>;
export function useGetActiveEquipmentTypesForSupplierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveEquipmentTypesForSupplierQuery,
        GetActiveEquipmentTypesForSupplierQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActiveEquipmentTypesForSupplierQuery | undefined,
  GetActiveEquipmentTypesForSupplierQueryVariables
>;
export function useGetActiveEquipmentTypesForSupplierSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveEquipmentTypesForSupplierQuery,
        GetActiveEquipmentTypesForSupplierQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetActiveEquipmentTypesForSupplierQuery,
    GetActiveEquipmentTypesForSupplierQueryVariables
  >(GetActiveEquipmentTypesForSupplierDocument, options);
}
export type GetActiveEquipmentTypesForSupplierQueryHookResult = ReturnType<
  typeof useGetActiveEquipmentTypesForSupplierQuery
>;
export type GetActiveEquipmentTypesForSupplierLazyQueryHookResult = ReturnType<
  typeof useGetActiveEquipmentTypesForSupplierLazyQuery
>;
export type GetActiveEquipmentTypesForSupplierSuspenseQueryHookResult = ReturnType<
  typeof useGetActiveEquipmentTypesForSupplierSuspenseQuery
>;
export type GetActiveEquipmentTypesForSupplierQueryResult = Apollo.QueryResult<
  GetActiveEquipmentTypesForSupplierQuery,
  GetActiveEquipmentTypesForSupplierQueryVariables
>;
export const GetTransportEquipmentCountsDocument = gql`
  query GetTransportEquipmentCounts(
    $externalSupplierId: ID!
    $status: TransportEquipmentCountStatus!
  ) {
    getTransportEquipmentCounts(externalSupplierId: $externalSupplierId, status: $status) {
      transportEquipmentCounts {
        id
        status
        externalSupplierId
        billNumber
        dateOfPickup
        deliveryImageUrls
        lineItems {
          equipmentTypeId
          name
          returned
          received
          photoUrl
          depositInEuros
        }
        createdAt
        updatedAt
        actor
      }
    }
  }
`;

/**
 * __useGetTransportEquipmentCountsQuery__
 *
 * To run a query within a React component, call `useGetTransportEquipmentCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportEquipmentCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransportEquipmentCountsQuery({
 *   variables: {
 *      externalSupplierId: // value for 'externalSupplierId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetTransportEquipmentCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  > &
    ({ variables: GetTransportEquipmentCountsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  >(GetTransportEquipmentCountsDocument, options);
}
export function useGetTransportEquipmentCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  >(GetTransportEquipmentCountsDocument, options);
}
// @ts-ignore
export function useGetTransportEquipmentCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTransportEquipmentCountsQuery,
  GetTransportEquipmentCountsQueryVariables
>;
export function useGetTransportEquipmentCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTransportEquipmentCountsQuery,
        GetTransportEquipmentCountsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTransportEquipmentCountsQuery | undefined,
  GetTransportEquipmentCountsQueryVariables
>;
export function useGetTransportEquipmentCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTransportEquipmentCountsQuery,
        GetTransportEquipmentCountsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTransportEquipmentCountsQuery,
    GetTransportEquipmentCountsQueryVariables
  >(GetTransportEquipmentCountsDocument, options);
}
export type GetTransportEquipmentCountsQueryHookResult = ReturnType<
  typeof useGetTransportEquipmentCountsQuery
>;
export type GetTransportEquipmentCountsLazyQueryHookResult = ReturnType<
  typeof useGetTransportEquipmentCountsLazyQuery
>;
export type GetTransportEquipmentCountsSuspenseQueryHookResult = ReturnType<
  typeof useGetTransportEquipmentCountsSuspenseQuery
>;
export type GetTransportEquipmentCountsQueryResult = Apollo.QueryResult<
  GetTransportEquipmentCountsQuery,
  GetTransportEquipmentCountsQueryVariables
>;
export const DeliverTransportEquipmentCountDocument = gql`
  mutation DeliverTransportEquipmentCount($input: DeliverTransportEquipmentCountInput!) {
    deliverTransportEquipmentCount(input: $input) {
      success
    }
  }
`;
export type DeliverTransportEquipmentCountMutationFn = Apollo.MutationFunction<
  DeliverTransportEquipmentCountMutation,
  DeliverTransportEquipmentCountMutationVariables
>;

/**
 * __useDeliverTransportEquipmentCountMutation__
 *
 * To run a mutation, you first call `useDeliverTransportEquipmentCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverTransportEquipmentCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverTransportEquipmentCountMutation, { data, loading, error }] = useDeliverTransportEquipmentCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliverTransportEquipmentCountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeliverTransportEquipmentCountMutation,
    DeliverTransportEquipmentCountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeliverTransportEquipmentCountMutation,
    DeliverTransportEquipmentCountMutationVariables
  >(DeliverTransportEquipmentCountDocument, options);
}
export type DeliverTransportEquipmentCountMutationHookResult = ReturnType<
  typeof useDeliverTransportEquipmentCountMutation
>;
export type DeliverTransportEquipmentCountMutationResult =
  Apollo.MutationResult<DeliverTransportEquipmentCountMutation>;
export type DeliverTransportEquipmentCountMutationOptions = Apollo.BaseMutationOptions<
  DeliverTransportEquipmentCountMutation,
  DeliverTransportEquipmentCountMutationVariables
>;
export const SaveTransportEquipmentCountDocument = gql`
  mutation SaveTransportEquipmentCount($input: SaveTransportEquipmentCountInput!) {
    saveTransportEquipmentCount(input: $input) {
      success
    }
  }
`;
export type SaveTransportEquipmentCountMutationFn = Apollo.MutationFunction<
  SaveTransportEquipmentCountMutation,
  SaveTransportEquipmentCountMutationVariables
>;

/**
 * __useSaveTransportEquipmentCountMutation__
 *
 * To run a mutation, you first call `useSaveTransportEquipmentCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTransportEquipmentCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTransportEquipmentCountMutation, { data, loading, error }] = useSaveTransportEquipmentCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTransportEquipmentCountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveTransportEquipmentCountMutation,
    SaveTransportEquipmentCountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveTransportEquipmentCountMutation,
    SaveTransportEquipmentCountMutationVariables
  >(SaveTransportEquipmentCountDocument, options);
}
export type SaveTransportEquipmentCountMutationHookResult = ReturnType<
  typeof useSaveTransportEquipmentCountMutation
>;
export type SaveTransportEquipmentCountMutationResult =
  Apollo.MutationResult<SaveTransportEquipmentCountMutation>;
export type SaveTransportEquipmentCountMutationOptions = Apollo.BaseMutationOptions<
  SaveTransportEquipmentCountMutation,
  SaveTransportEquipmentCountMutationVariables
>;
